import { Outlet } from 'react-router-dom';
import { useContext, useMemo } from 'react';
import { useBookitupMailFolderCounts } from '../hooks/useBookitupMailFolderCounts';
import { PostboxCountersContext } from './PostboxCountersContext';
import { EventParticipationsContext } from './EventParticipationContextV2';

// eslint-disable-next-line import/prefer-default-export
export const EventPostboxCountsProvider = () => {
  const { participations } = useContext(EventParticipationsContext);
  const contactIds = useMemo(() => participations.map((p) => p.contactId), [participations]);
  const value = useBookitupMailFolderCounts(contactIds.length === 0 ? null : contactIds);

  return (
    <PostboxCountersContext.Provider value={value}>
      <Outlet />
    </PostboxCountersContext.Provider>
  );
};
